import { ReturnProcessingInformationState } from "@redotech/redo-return-ui/flows/return-flow/return-processing-information";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const ReturnProcessingInformationDetails = memo(
  function ReturnProcessingInformationDetails({
    stepSelect,
    state,
    setState,
  }: StepTypeDetailsProps<ReturnProcessingInformationState>) {
    return (
      <Flex dir="column" gap="md">
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Header
          </Text>
          <RedoTextInput
            placeholder="Step heading"
            setValue={(header) => setState((state) => ({ ...state, header }))}
            value={state.header}
          />
        </Flex>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Message
          </Text>
          <RedoTextareaInputField
            placeholder="Instructions shown to the warehouse worker"
            setValue={(message) => setState((state) => ({ ...state, message }))}
            value={state.message}
          />
        </Flex>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Continue button text
          </Text>
          <RedoTextInput
            placeholder="Continue"
            setValue={(continueButtonText) =>
              setState((state) => ({ ...state, continueButtonText }))
            }
            value={state.continueButtonText}
          />
        </Flex>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Next step
          </Text>
          {stepSelect({
            value: state.next,
            valueChange: (next) => setState((state) => ({ ...state, next })),
            handleIndex: 0,
          })}
        </Flex>
      </Flex>
    );
  },
);
